import axios from 'axios'

const apiBroker = axios.create({
    baseURL: process.env.VUE_APP_BROKER_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

export default apiBroker